import axios from 'axios';
import { InvoiceCreateBody, InvoiceGetAllQuery } from '../../types';

class InvoicesService {
  create = (clientYardIds: string[], body: InvoiceCreateBody) =>
    axios.post(`/invoices/`, { ...body, clientYardIds });

  getByClientYards = (props?: any) => axios.get(`/invoices/client-yards`, props);

  getAll = (clientYardId: string, props?: any) =>
    axios.get<InvoiceGetAllQuery>(`/invoices/client-yard/${clientYardId}`, props);

  getOne = (invoiceId: string) => axios.get(`/invoices/${invoiceId}`);

  setPending = ({ yardId, ids }: { yardId: string; ids: string[] }) => {
    const props = ids || { yardId };
    return axios.patch(`/invoices/pending`, props);
  };

  setPaid = (invoiceId: string) => axios.patch(`/invoices/${invoiceId}/paid`);

  delete = (invoiceId: string) => axios.delete(`/invoices/${invoiceId}`);
}

export const invoicesService = new InvoicesService();
